import { render, staticRenderFns } from "./uploadPayCsv.vue?vue&type=template&id=53084b52&scoped=true"
import script from "./uploadPayCsv.vue?vue&type=script&lang=js"
export * from "./uploadPayCsv.vue?vue&type=script&lang=js"
import style0 from "./uploadPayCsv.vue?vue&type=style&index=0&id=53084b52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53084b52",
  null
  
)

export default component.exports